import * as React from 'react';
import Stack from '@mui/material/Stack';
import { EmptyState } from '../../common';
import { useTranslation } from 'react-i18next';

import { GetConsumerDetailedQuery } from '@graphql';
import { Restricted } from '../Restricted';

interface HomeProps {
  consumer: GetConsumerDetailedQuery['consumer'];
}

function Home(props: Readonly<HomeProps>) {
  const { consumer } = props;
  const { t } = useTranslation('account');

  return (
    <Stack spacing={5} p={3}>
      {consumer.isMyFriend ? <EmptyState text={t('text.No news yet')} /> : <Restricted />}
    </Stack>
  );
}

export default React.memo(Home);
